export default __webpack_public_path__ + "static/media/blog-level-5.27ec9a31.svg";